import { useNavigate, useLocation } from "react-router-dom";

/**
 * Hook to reload the current route using React Router
 * This will remount the current page component without reloading the entire page
 */
export function useReloadRoute() {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    // Navigate to the same route with a refresh state to force remount
    navigate(location.pathname + location.search, {
      replace: true,
      state: { refresh: Date.now() },
    });
  };
}

/**
 * Utility function to reload current route from outside React components
 * Uses window.location to get current path and navigates to it
 */
export function reloadCurrentRoute(navigate) {
  const pathname = window.location.pathname;
  const search = window.location.search;
  
  navigate(pathname + search, {
    replace: true,
    state: { refresh: Date.now() },
  });
}

